import { useParams } from "react-router-dom";
import { useStateMachine } from "little-state-machine";

import { useGetQuickRequestDetails } from "api/queries/quick-request/useGetQuickRequestDetails";
import { useGetShipmentBasic } from "api/queries/shipments/useGetShipmentBasic";
import ConvertQR from "components/molecules/TopNav/shipper/NavIcons/ConvertQR";
import usePermissions from "hooks/usePermissions";

interface ShipperActionButtonsProps {
  isQuickRequest: boolean;
}

export default function ShipperActionButtons({ isQuickRequest }: ShipperActionButtonsProps) {
  const { state } = useStateMachine() as any;
  const { id } = useParams();
  const shipmentId = (id || state.shipmentId) as string;

  const { permissions } = usePermissions();
  const canCreateQuoteRequest = permissions && JSON.parse(permissions).permissions.quoting.create_quote_requests;

  const { data: shipmentBasicData }: any = useGetShipmentBasic(shipmentId, {
    enabled: !isQuickRequest && !!shipmentId,
    refetchOnMount: false,
  });
  const { data: quickDetailsData }: any = useGetQuickRequestDetails(shipmentId, {
    enabled: isQuickRequest && !!shipmentId,
    refetchOnMount: false,
  });

  const hasRelatedShipment = Boolean(
    isQuickRequest
      ? quickDetailsData?.related_request?.related_request_id
      : shipmentBasicData?.related_request?.related_request_id,
  );

  const status = isQuickRequest
    ? quickDetailsData?.organization?.quick_request_status
    : shipmentBasicData?.organization?.request_status;

  return (
    <>
      {/* Convert to Shipment (quick request only) */}
      {isQuickRequest && canCreateQuoteRequest && !hasRelatedShipment && status !== "Canceled" && <ConvertQR />}
    </>
  );
}
